(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["countdown-timer"] && !Shopify.designMode) return;
  try {
    class CountdownTimer extends HTMLElement {
    constructor() {
      super();
      this.intervalId = null;
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
    }

    init() {
      const endDate = this.dataset.endDate;
      const format = this.dataset.format || 'dms';
      const showLabels = this.dataset.showLabels === 'true';

      if (!endDate) {
        console.warn('Countdown Timer: No end date specified');
        return;
      }

      this.updateTimer(endDate, format);
      this.intervalId = setInterval(() => this.updateTimer(endDate, format), 1000);
    }

    updateTimer(endDateStr, format) {
      const endDate = new Date(endDateStr).getTime();
      const now = new Date().getTime();
      const distance = endDate - now;

      if (distance < 0) {
        this.handleExpiration();
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      const units = {
        days,
        hours: this.padZero(hours),
        minutes: this.padZero(minutes),
        seconds: this.padZero(seconds),
      };

      // Update display based on format
      this.updateDisplay(units, format);
    }

    updateDisplay(units, format) {
      const daysEl = this.querySelector('[data-unit="days"] .countdown-timer__number');
      const hoursEl = this.querySelector('[data-unit="hours"] .countdown-timer__number');
      const minutesEl = this.querySelector('[data-unit="minutes"] .countdown-timer__number');
      const secondsEl = this.querySelector('[data-unit="seconds"] .countdown-timer__number');

      if (daysEl) daysEl.textContent = this.padZero(units.days);
      if (hoursEl) hoursEl.textContent = units.hours;
      if (minutesEl) minutesEl.textContent = units.minutes;
      if (secondsEl) secondsEl.textContent = units.seconds;
    }

    padZero(num) {
      return String(num).padStart(2, '0');
    }

    handleExpiration() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }

      const hideOnExpire = this.dataset.hideOnExpire === 'true';
      const expireAction = this.dataset.expireAction;
      const expireMessage = this.dataset.expireMessage;
      const expireUrl = this.dataset.expireUrl;

      const displayEl = this.querySelector('.countdown-timer__display');
      const expiredEl = this.querySelector('.countdown-timer__expired');

      if (hideOnExpire && displayEl) {
        displayEl.style.display = 'none';
      }

      if (expiredEl) {
        expiredEl.style.display = 'block';
      }

      if (expireAction === 'redirect' && expireUrl) {
        setTimeout(() => {
          window.location.href = expireUrl;
        }, 2000);
      }
    }
  }

  customElements.define('countdown-timer', CountdownTimer);
  } catch(e) { console.error(e); }
})();

})();
